export const BAG_SIZE_EXCEEDED = "BagExceededMaxItems";
export const BRAND_QUANTITY_EXCEEDED = "QuantityExceededForBrand";
export const VARIANT_QUANTITY_EXCEEDED = "QuantityOutOfRangeForVariant";
export const VOUCHER_IN_THE_BAG = "CannotAddProductToBagContainingVoucher";
export const OUT_OF_STOCK = "OutOfStock";
export const OUT_OF_ADDITIONAL_STOCK = "OutOfAdditionalStock";
